import { ApiEndPoint } from '@/domains/api/api.entity';
import type { CareerLayerApiResponse } from '@/domains/careerLayer/careerLayer.entity';
import { apiRequest } from './apiRequest';

/**
 * Implementación de la lógica para llamar al API de careerLayer
 */
class CareerLayerApiService {
  /**
   * Obtención de datos completos de careerLayer desde el endpoint
   */
  async getCareerLayer(career: string): Promise<CareerLayerApiResponse> {
    /**
     * GET para obtener datos completos de careerLayer
     * Recibe parámetro dinámico career (ej: codCareera)
     */
    const careerLayerResponse = await apiRequest.get<CareerLayerApiResponse>({
      route: ApiEndPoint.LAYER_CAREER,
      param: `/${career}`,
    });

    return careerLayerResponse;
  }
}

export const careerLayerApiService = new CareerLayerApiService();
